import React from 'react';
import Button from '../Button';
import './styles.css';

/**
 * 確認對話框組件
 * 用於顯示確認操作的對話框
 * 
 * @param {Object} props - 組件屬性
 * @param {boolean} props.isOpen - 是否顯示對話框
 * @param {string} props.title - 對話框標題
 * @param {string} props.message - 對話框消息
 * @param {string} props.confirmText - 確認按鈕文本
 * @param {string} props.cancelText - 取消按鈕文本
 * @param {Function} props.onConfirm - 確認回調函數
 * @param {Function} props.onCancel - 取消回調函數
 * @param {boolean} props.isLoading - 是否顯示加載狀態
 * @param {string} props.error - 錯誤信息
 * @param {string} props.className - 額外的CSS類名
 * @returns {JSX.Element|null} 確認對話框組件
 */
function ConfirmDialog({
    isOpen,
    title = '確認',
    message = '您確定要執行此操作嗎？',
    confirmText = '確認',
    cancelText = '取消',
    onConfirm,
    onCancel,
    isLoading = false,
    error = null,
    className = ''
}) {
    if (!isOpen) return null;

    return (
        <div className="confirm-dialog-overlay">
            <div className={`confirm-dialog ${className}`}>
                <div className="confirm-dialog-header">
                    <h3 className="confirm-dialog-title">{title}</h3>
                </div>
                <div className="confirm-dialog-body">
                    <p className="confirm-dialog-message">{message}</p>
                    {error && (
                        <p className="confirm-dialog-error">{error}</p>
                    )}
                </div>
                <div className="confirm-dialog-footer">
                    <Button
                        variant="secondary"
                        onClick={onCancel}
                        className="confirm-dialog-button"
                        disabled={isLoading}
                    >
                        {cancelText}
                    </Button>
                    <Button
                        variant="danger"
                        onClick={onConfirm}
                        className="confirm-dialog-button"
                        disabled={isLoading}
                    >
                        {isLoading ? '處理中...' : confirmText}
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmDialog; 